
import React, { useState, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import PaginationTable from './Container/Common/PaginationTable';
import { useNavigate, useLocation } from 'react-router-dom';
import { API_CONFIG } from './config/apiConfig';
import apiService from './services/ApiService';
//import { Header, Icon, Table } from 'semantic-ui-react';

const Dashboard = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { authState, oktaAuth } = useOktaAuth();
    const [userInfo, setUserInfo] = useState(null);
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);

    const TABLE_HEADERS = ["ID","Company","Environment","Requestor Name","API Client","Status","Date Created","Last Modified"]
    const TABLE_FIELDS=["id","companyName","environment","firstName","apiClientAccess","questions","createDate","createDate"]

    useEffect(() => {
        if (!authState || !authState.isAuthenticated) {
            // When user isn't authenticated, forget any user info
            setUserInfo(null);
        } else {
            setUserInfo(authState.idToken.claims);
            // You can also get user information from the `/userinfo` endpoint
            /*oktaAuth.getUser().then((info) => {
              setUserInfo(info);
            });*/
        }
    }, [authState, oktaAuth]); // Update if authState changes

    // Note: the empty deps array [] means
    // this useEffect will run once
    // similar to componentDidMount()
    useEffect(() => {
        const fetchItems = async () => {
            try {
                const result = await apiService.get(API_CONFIG.ENDPOINTS.ITEMS, {
                    headers: {
                        'Authorization': `Bearer ${authState.accessToken.accessToken}`
                    }
                });
                setIsLoaded(true);
                setItems(result.Items);
            } catch (error) {
                setIsLoaded(true);
                setError(error);
                console.error('Failed to fetch items:', error.message);
                
                // Show user-friendly error message for CORS
                if (error.message.includes('CORS')) {
                    alert('API access is currently blocked due to CORS configuration. Please contact the backend team to resolve this issue.');
                }
            }
        };

        if (authState.accessToken) {
            fetchItems();
        }
    }, [authState.accessToken?.accessToken])

    const handleRedirect = (data) => {
        navigate("/onboardingRequestForm", {
            state: {viewDetails: data, path: location}
        })
    }

    if (!userInfo) {
        return (
            <div>
                <p>Fetching user profile...</p>
            </div>
        );
    }
    else if (error) {
        return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
        return <div className='full-height-page margin-left-large margin-top-large font-size-large'>Loading...</div>;
    } else {
        return (
            <>
            {/* <SearchResult result={items} /> */}
            
            <div className='width-100 padding-around-10 no-padding-top  background-color-white full-height-page'>
                <div className='col-12 background-color-white padding-around-10'>
                    <span className='obf-header padding-around-10'>Service API Onboarding Request Search Result</span>
                </div>
                <div className='col-12 background-color-white padding-around-10'>
                    <span className='obf-small-header padding-around-10'>Open Service API Onboarding Request Forms</span>
                </div>
                <PaginationTable 
                    tableHeaders={TABLE_HEADERS}
                    tableFields={TABLE_FIELDS}
                    tableData={items}
                    handleRedirect={handleRedirect}
                />
            </div>
            </>
        );
    }

};

export default Dashboard;

